(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var toggle = document.querySelector('.nav-toggle');
    var nav = document.getElementById('SiteNav');
    if (!toggle || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.innerHTML = open ? '&#10005;' : '&#9776;';
    }

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  /* ---------- Lightbox ---------- */
  function initLightbox() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox]'));
    if (!triggers.length) return;

    var box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML =
      '<button class="lightbox__close" aria-label="Close">&#10005;</button>' +
      '<button class="lightbox__nav lightbox__prev" aria-label="Previous image">&#8249;</button>' +
      '<img alt="">' +
      '<button class="lightbox__nav lightbox__next" aria-label="Next image">&#8250;</button>';
    document.body.appendChild(box);

    var img = box.querySelector('img');
    var closeBtn = box.querySelector('.lightbox__close');
    var prevBtn = box.querySelector('.lightbox__prev');
    var nextBtn = box.querySelector('.lightbox__next');
    var index = 0;
    var lastFocus = null;

    var groups = {};
    var single = [];
    triggers.forEach(function (t) {
      var name = t.getAttribute('data-lightbox-group');
      if (name) {
        if (!groups[name]) groups[name] = [];
        groups[name].push(t);
      } else {
        single.push(t);
      }
    });
    var active = [];

    function show(i) {
      if (!active.length) return;
      index = (i + active.length) % active.length;
      var t = active[index];
      img.src = t.getAttribute('data-lightbox');
      img.alt = t.getAttribute('data-alt') || '';
    }

    function openGroup(name, i) {
      active = groups[name] || [];
      lastFocus = document.activeElement;
      show(i);
      prevBtn.style.display = active.length > 1 ? '' : 'none';
      nextBtn.style.display = active.length > 1 ? '' : 'none';
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function openSingle(t) {
      active = [];
      lastFocus = document.activeElement;
      img.src = t.getAttribute('data-lightbox');
      img.alt = t.getAttribute('data-alt') || '';
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Object.keys(groups).forEach(function (name) {
      groups[name].forEach(function (t, i) {
        t.addEventListener('click', function (e) { e.preventDefault(); openGroup(name, i); });
      });
    });
    single.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openSingle(t); });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (active.length > 1 && prevBtn.style.display !== 'none') {
        if (e.key === 'ArrowLeft') show(index - 1);
        if (e.key === 'ArrowRight') show(index + 1);
      }
      if (e.key === 'Tab') {
        var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return b.style.display !== 'none'; });
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
  }

  /* ---------- Product image thumbs ---------- */
  function initThumbs() {
    var main = document.getElementById('mainImage');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-thumb');
        main.setAttribute('data-lightbox', t.getAttribute('data-full') || t.getAttribute('data-thumb'));
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var root = document.getElementById('ProductForm');
    if (!root) return;
    var dataEl = document.getElementById('VariantData');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var idInput = root.querySelector('#VariantId');
    var priceEl = document.getElementById('ProductPrice');
    var btn = root.querySelector('#AddToCart');
    if (!selects.length || !idInput) return;

    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    function money(cents) {
      var noDecimals = /no_decimals/.test(fmt);
      var commaSep = /comma_separator/.test(fmt);
      var aposSep = /apostrophe_separator/.test(fmt);
      var thousands = commaSep ? '.' : (aposSep ? "'" : ',');
      var decimal = commaSep ? ',' : '.';

      var value = cents / 100;
      var str = noDecimals ? String(Math.round(value)) : value.toFixed(2);
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      str = parts.join(decimal);

      return fmt.replace(/\{\{\s*\w+\s*\}\}/, str);
    }

    function renderPrice(v) {
      if (!priceEl) return;
      var cur = priceEl.querySelector('.price__current');
      var cmp = priceEl.querySelector('.price__compare');
      var cmpAmt = priceEl.querySelector('.price__compare-amount');
      var badge = priceEl.querySelector('.price__badge');
      var onSale = v.compare_at_price > v.price;

      if (cur) {
        cur.textContent = money(v.price);
        cur.classList.toggle('price__current--sale', onSale);
      }
      if (cmp) cmp.hidden = !onSale;
      if (cmpAmt && onSale) cmpAmt.textContent = money(v.compare_at_price);
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) {
          badge.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
        }
      }
    }

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }

      if (!match) {
        idInput.value = '';
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }

      idInput.value = match.id;
      renderPrice(match);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart — ' + money(match.price) : 'Sold Out';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function init() {
    initNav();
    initLightbox();
    initThumbs();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
